export default {
  currentTrackId: state => state.currentTrackId,
  currentIndex: state => state.currentIndex,
  tracklist: state => state.tracklist || {},
  inQueue: state => id => Boolean(state.tracklist.includes(id)),
  position: state => state.position
};
